/**
 * @generated SignedSource<<a8fc0565abf952e5dbc8ccd22e2e707d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DagvestigationDetails_jobRun$data = {
  readonly id: any;
  readonly investigation: {
    readonly id: any;
    readonly summary: string;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"DagvestigationJobDetails_jobRun">;
  readonly " $fragmentType": "DagvestigationDetails_jobRun";
};
export type DagvestigationDetails_jobRun$key = {
  readonly " $data"?: DagvestigationDetails_jobRun$data;
  readonly " $fragmentSpreads": FragmentRefs<"DagvestigationDetails_jobRun">;
};

import DagvestigationDetailsJobRunRefetchQuery_graphql from './DagvestigationDetailsJobRunRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": DagvestigationDetailsJobRunRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "DagvestigationDetails_jobRun",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DagvestigationJobDetails_jobRun"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLInvestigation",
      "kind": "LinkedField",
      "name": "investigation",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLJobRun",
  "abstractKey": null
};
})();

(node as any).hash = "ac2d9b78d7539c85795fc0a5f82be2d0";

export default node;
